import { configureStore } from "@reduxjs/toolkit";
import { IAOPRanking } from "../interfaces/models/IAOPRanking";
import FirmProfileReducer from "./states/firmProfile.state";
import loaderReducer from "./loaderReducer";
import { iframeReducer } from "./iframeReducer";
import {
  ICountry,
  ILanguage,
  IPerson,
  IRegion,
  IState,
  ISubstate,
  ICity,
} from "../interfaces";
import {
  stateSlice,
  countrySlice,
  languageSlice,
  personSlice,
  regionSlice,
  substateSlice,
  aopRankingSlice,
  contentsSlice,
  citySlice,
  manageFirmSlice,
  menuSlice,
  pageState,
  eventSlice,
  eventSelectedTabSlice,
  staffEventSelectedTabSlice,
  editParticipantSlice,
} from "./states";
import { userPreferencesReducer } from "./states/userPreferences.state";
import {
  contentGeneralTopicsSlice,
  contentTagsSlice,
  countriesSlice,
  firmsSlice,
  globalCrisisSlice,
  groupsSlice,
  practiceIndustriesSlice,
  regionsSlice,
  statesSlice,
  citiesSlice,
} from "./catalogs/states";
import { IRepresentativeClient } from "../interfaces/models/IRepresentativeClient";
import { representativeClientSlice } from "./states/representativeClient.state";
import { contentContext } from "./emptyStates";
import { IManageFirm } from "../interfaces/models/IManageFirm";
import { IEvent } from "../interfaces/models/IEvent";
import { IUserPreferences } from "../interfaces/models/IUserPreferences";
import {
  type EditParticipantState,
} from "./emptyStates/EditParticipant";

export interface Appstore {
  state: IState;
  city: any;
  substate: ISubstate;
  region: IRegion;
  country: ICountry;
  language: ILanguage;
  person: IPerson;
  representativeClient: IRepresentativeClient;
  aopRanking: IAOPRanking;
  contentGeneralTopics: any[];
  contentTags: any[];
  countries: any[];
  groups: any[];
  content: contentContext;
  firms: any[];
  globalCrisis: any[];
  practiceIndustries: any[];
  regions: any[];
  cities: ICity[];
  states: any[];
  firmProfile: any;
  loader: any;
  manageFirm: IManageFirm;
  menus: any;
  pageState: any;
  iframe: any;
  event: IEvent;
  eventSelectedTab: { selectedTab: number };
  staffEventSelectedTab: { selectedTab: number };
  editParticipant: EditParticipantState;
  userPreferences: {
    userPreferences: IUserPreferences | null;
    loading: boolean;
    error: Error | null;
  };
}

const devToolsConfig = { devTools: process.env.NODE_ENV !== "production" };

const store = configureStore<Appstore>({
  reducer: {
    firmProfile: FirmProfileReducer,
    state: stateSlice.reducer,
    substate: substateSlice.reducer,
    region: regionSlice.reducer,
    country: countrySlice.reducer,
    language: languageSlice.reducer,
    person: personSlice.reducer,
    aopRanking: aopRankingSlice.reducer,
    representativeClient: representativeClientSlice.reducer,
    contentGeneralTopics: contentGeneralTopicsSlice.reducer,
    contentTags: contentTagsSlice.reducer,
    countries: countriesSlice.reducer,
    groups: groupsSlice.reducer,
    firms: firmsSlice.reducer,
    globalCrisis: globalCrisisSlice.reducer,
    practiceIndustries: practiceIndustriesSlice.reducer,
    regions: regionsSlice.reducer,
    content: contentsSlice.reducer,
    states: statesSlice.reducer,
    cities: citiesSlice.reducer,
    city: citySlice.reducer,
    event: eventSlice.reducer,
    loader: loaderReducer,
    manageFirm: manageFirmSlice.reducer,
    menus: menuSlice.reducer,
    pageState: pageState.reducer,
    iframe: iframeReducer,
    eventSelectedTab: eventSelectedTabSlice.reducer,
    staffEventSelectedTab: staffEventSelectedTabSlice.reducer,
    editParticipant: editParticipantSlice.reducer,
    userPreferences: userPreferencesReducer,
  },
  ...devToolsConfig,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
